import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { StringHelper } from 'src/app/helpers/string-helper';
import { ProperPageResult } from 'src/app/model/proper-page-result';
import { LoadingService } from '../../loading.service';
import { SnackService } from '../../snack.service';
import { Observable } from 'rxjs';
import { _get, _post, _put } from '../../base.service';

export abstract class SignAssociationControllerRequestService<T, O> {
  private readonly get: <T>(
    path: string,
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly post: <T>(
    path: string,
    body: T,
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly put: <T>(
    path: string,
    body: T,
    deserialize: (response: any) => T
  ) => Observable<T>;

  private readonly delete: (path: string) => Observable<void>;

  protected abstract deserializeImpl(): (res: any) => T;
  private readonly deserializePage = (res) => {
    const result: ProperPageResult<O> = new ProperPageResult();
    result.totalItems = res.totalItems;
    result.items = res.items;
    return result;
  };

  protected constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router,
    controllerUrl: string
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.get = _get(controllerUrl, requestServices);
    this.post = _post(controllerUrl, requestServices);
    this.put = _put(controllerUrl, requestServices);
  }

  public getPaged(
    signId: number,
    filters: string,
    sort: string,
    sortAscending: boolean,
    pageSize: number,
    page: number,
    showArchived: boolean
  ): Promise<ProperPageResult<O>> {
    const filtersValue = StringHelper.isEmpty(filters)
      ? `signId${encodeURIComponent('=')}${signId}`
      : `${filters},signId${encodeURIComponent('=')}${signId}`;
    const filtersParam = `filters=${filtersValue}`;
    const pageableParam: string = `page=${page}&size=${pageSize}&sortDirection=${
      sortAscending ? 'ASC' : 'DESC'
    }&sortProperty=${sort}`;
    const showArchivedParam: string = `showArchived=${showArchived}`;
    const pathParams: string = `?${filtersParam}&${pageableParam}&${showArchivedParam}`;

    return this.get(pathParams, this.deserializePage).toPromise();
  }

  public getById(id: number): Promise<T> {
    return this.get(`/${id}`, this.deserializeImpl()).toPromise();
  }

  public create(assocObject: T, signId: number): Promise<T> {
    return this.post(
      `/${signId}`,
      assocObject,
      this.deserializeImpl()
    ).toPromise();
  }

  public update(assocObject: T, signId: number): Promise<T> {
    return this.put(
      `/${signId}`,
      assocObject,
      this.deserializeImpl()
    ).toPromise();
  }

  public archive(id: number): Promise<void> {
    return this.delete(`/${id}`).toPromise();
  }
}
